import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class AllPermissionsService extends BaseService {
  constructor() {
    super(constants.GET_PERMISSIONS, 'allpermissionsStatus');
  }

  handleEvent() {
    return this.getClient('evergreen').get('/permissions');
  }

  handleResponse(response) {
    // eslint-disable-line class-methods-use-this
    if (response.data.length > 0) {
      Framework.getStoreRegistry().getStore('permissions').set(response.data);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
    }
  }
}
